import { useMemo } from "react";

import noop from "lodash/noop";

import { GraphMetricCard } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { percentageSignFilter } from "app/filters/ngFilters";
import { CardBenchmarkRow } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/CardBenchmarkRow";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import type { IVisibilityMetricCardProps } from "../types";
import { getGraphDataFromArray, getPopChangeValueProps, GRAPH_PROPS_WITH_PERCENTAGE } from "../utils";
import { MetricCardSecondary } from "../MetricCardSecondary";

export const VisibilityMetricCard = ({ metric, visibilityRank, hasData, isLoading }: IVisibilityMetricCardProps) => {
    const translate = useTranslation();
    const graphData = useMemo(() => getGraphDataFromArray(metric.dailyData, "brandVisibility"), [metric.dailyData]);

    return (
        <GraphMetricCard
            data-automation="brand-overview-visibility-card"
            title={translate("llm.brand_overview.visibility.title")}
            tooltip={translate("llm.brand_overview.visibility.tooltip", {
                brand: metric.brandName,
            })}
            secondaryValue={
                hasData ? (
                    <MetricCardSecondary
                        caption={{
                            textKey: "llm.brand_overview.visibility.text",
                            brand: metric.brandName,
                            mentions: metric.mentions,
                            total: metric.total,
                        }}
                        benchmark={
                            visibilityRank != null ? (
                                <CardBenchmarkRow
                                    label={translate("llm.brand_overview.visibility.rank")}
                                    formattedValue={`#${visibilityRank}`}
                                    valueColor={colorsPalettes.carbon[400]}
                                    dataAutomation="brand-overview-visibility-core-rank"
                                />
                            ) : null
                        }
                    />
                ) : null
            }
            value={hasData ? percentageSignFilter()(metric.share, 2) : null}
            changeValueProps={hasData ? getPopChangeValueProps(metric.shareChange) : undefined}
            isLoading={isLoading}
            graphProps={{
                ...GRAPH_PROPS_WITH_PERCENTAGE,
                data: graphData,
            }}
            onCtaClick={noop}
        />
    );
};
